import ee from "react";
var v = { exports: {} }, _ = {};
var F;
function re() {
  if (F) return _;
  F = 1;
  var o = /* @__PURE__ */ Symbol.for("react.transitional.element"), f = /* @__PURE__ */ Symbol.for("react.fragment");
  function u(c, s, l) {
    var m = null;
    if (l !== void 0 && (m = "" + l), s.key !== void 0 && (m = "" + s.key), "key" in s) {
      l = {};
      for (var p in s)
        p !== "key" && (l[p] = s[p]);
    } else l = s;
    return s = l.ref, {
      $$typeof: o,
      type: c,
      key: m,
      ref: s !== void 0 ? s : null,
      props: l
    };
  }
  return _.Fragment = f, _.jsx = u, _.jsxs = u, _;
}
var E = {};
var I;
function te() {
  return I || (I = 1, process.env.NODE_ENV !== "production" && (function() {
    function o(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === Z ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case T:
          return "Fragment";
        case q:
          return "Profiler";
        case W:
          return "StrictMode";
        case z:
          return "Suspense";
        case B:
          return "SuspenseList";
        case H:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case L:
            return "Portal";
          case J:
            return e.displayName || "Context";
          case G:
            return (e._context.displayName || "Context") + ".Consumer";
          case V:
            var r = e.render;
            return e = e.displayName, e || (e = r.displayName || r.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case X:
            return r = e.displayName || null, r !== null ? r : o(e.type) || "Memo";
          case x:
            r = e._payload, e = e._init;
            try {
              return o(e(r));
            } catch {
            }
        }
      return null;
    }
    function f(e) {
      return "" + e;
    }
    function u(e) {
      try {
        f(e);
        var r = !1;
      } catch {
        r = !0;
      }
      if (r) {
        r = console;
        var t = r.error, n = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t.call(
          r,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          n
        ), f(e);
      }
    }
    function c(e) {
      if (e === T) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === x)
        return "<...>";
      try {
        var r = o(e);
        return r ? "<" + r + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function s() {
      var e = y.A;
      return e === null ? null : e.getOwner();
    }
    function l() {
      return Error("react-stack-top-frame");
    }
    function m(e) {
      if (w.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function p(e, r) {
      function t() {
        P || (P = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          r
        ));
      }
      t.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: t,
        configurable: !0
      });
    }
    function M() {
      var e = o(this.type);
      return N[e] || (N[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function U(e, r, t, n, R, k) {
      var a = t.ref;
      return e = {
        $$typeof: A,
        type: e,
        key: r,
        props: t,
        _owner: n
      }, (a !== void 0 ? a : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: M
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: R
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: k
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function S(e, r, t, n, R, k) {
      var a = r.children;
      if (a !== void 0)
        if (n)
          if (Q(a)) {
            for (n = 0; n < a.length; n++)
              j(a[n]);
            Object.freeze && Object.freeze(a);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else j(a);
      if (w.call(r, "key")) {
        a = o(e);
        var d = Object.keys(r).filter(function(K) {
          return K !== "key";
        });
        n = 0 < d.length ? "{key: someKey, " + d.join(": ..., ") + ": ...}" : "{key: someKey}", $[a + n] || (d = 0 < d.length ? "{" + d.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          n,
          a,
          d,
          a
        ), $[a + n] = !0);
      }
      if (a = null, t !== void 0 && (u(t), a = "" + t), m(r) && (u(r.key), a = "" + r.key), "key" in r) {
        t = {};
        for (var O in r)
          O !== "key" && (t[O] = r[O]);
      } else t = r;
      return a && p(
        t,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), U(
        e,
        a,
        t,
        s(),
        R,
        k
      );
    }
    function j(e) {
      g(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e !== null && e.$$typeof === x && (e._payload.status === "fulfilled" ? g(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
    }
    function g(e) {
      return typeof e == "object" && e !== null && e.$$typeof === A;
    }
    var b = ee, A = /* @__PURE__ */ Symbol.for("react.transitional.element"), L = /* @__PURE__ */ Symbol.for("react.portal"), T = /* @__PURE__ */ Symbol.for("react.fragment"), W = /* @__PURE__ */ Symbol.for("react.strict_mode"), q = /* @__PURE__ */ Symbol.for("react.profiler"), G = /* @__PURE__ */ Symbol.for("react.consumer"), J = /* @__PURE__ */ Symbol.for("react.context"), V = /* @__PURE__ */ Symbol.for("react.forward_ref"), z = /* @__PURE__ */ Symbol.for("react.suspense"), B = /* @__PURE__ */ Symbol.for("react.suspense_list"), X = /* @__PURE__ */ Symbol.for("react.memo"), x = /* @__PURE__ */ Symbol.for("react.lazy"), H = /* @__PURE__ */ Symbol.for("react.activity"), Z = /* @__PURE__ */ Symbol.for("react.client.reference"), y = b.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, w = Object.prototype.hasOwnProperty, Q = Array.isArray, h = console.createTask ? console.createTask : function() {
      return null;
    };
    b = {
      react_stack_bottom_frame: function(e) {
        return e();
      }
    };
    var P, N = {}, C = b.react_stack_bottom_frame.bind(
      b,
      l
    )(), Y = h(c(l)), $ = {};
    E.Fragment = T, E.jsx = function(e, r, t) {
      var n = 1e4 > y.recentlyCreatedOwnerStacks++;
      return S(
        e,
        r,
        t,
        !1,
        n ? Error("react-stack-top-frame") : C,
        n ? h(c(e)) : Y
      );
    }, E.jsxs = function(e, r, t) {
      var n = 1e4 > y.recentlyCreatedOwnerStacks++;
      return S(
        e,
        r,
        t,
        !0,
        n ? Error("react-stack-top-frame") : C,
        n ? h(c(e)) : Y
      );
    };
  })()), E;
}
var D;
function ne() {
  return D || (D = 1, process.env.NODE_ENV === "production" ? v.exports = re() : v.exports = te()), v.exports;
}
var i = ne();
const oe = ({ variant: o = "primary", style: f, ...u }) => {
  const c = {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    backgroundColor: o === "primary" ? "#0070f3" : "#eaeaea",
    color: o === "primary" ? "#fff" : "#000",
    ...f
  };
  return /* @__PURE__ */ i.jsx("button", { style: c, ...u });
}, se = ({ id: o, baseFrequency: f = "0.015 0.1", children: u, scale: c = 30 }) => /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
  /* @__PURE__ */ i.jsx("svg", { style: { display: "none" }, children: /* @__PURE__ */ i.jsx("defs", { children: /* @__PURE__ */ i.jsxs("filter", { id: o, colorInterpolationFilters: "linearRGB", filterUnits: "objectBoundingBox", primitiveUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ i.jsx(
      "feTurbulence",
      {
        type: "turbulence",
        baseFrequency: f,
        numOctaves: "2",
        seed: "2",
        stitchTiles: "stitch",
        x: "0%",
        y: "0%",
        width: "100%",
        height: "100%",
        result: "turbulence"
      }
    ),
    /* @__PURE__ */ i.jsx(
      "feDisplacementMap",
      {
        in: "SourceGraphic",
        in2: "turbulence",
        scale: c,
        xChannelSelector: "R",
        yChannelSelector: "B",
        x: "0%",
        y: "0%",
        width: "100%",
        height: "100%",
        result: "displacementMap"
      }
    )
  ] }) }) }),
  /* @__PURE__ */ i.jsx("div", { style: { filter: `url(#${o})` }, children: u })
] });
export {
  oe as Button,
  se as Feturbulence
};
